export default __webpack_public_path__ + "ed14a60bc44e9ae12da26d8e746184ae.png";